import { jsx as _jsx } from 'react/jsx-runtime.js';
import { useTranslation } from '@stepstone-platform/i18n';
import { useEffect } from 'react';
import { Input } from '../../common/Input/index.js';
import { validateEmail } from '../../../helpers/validateEmail.js';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.js';
import { emailSelector, updateEmail, updateEmailError, updateEmailErrorMessage, } from '../../../views/Login/loginSlice.js';
import { activeViewSelector, setActiveView, } from '../../../redux/core/wrapperContext/wrapperContextSlice.js';
import { FORM_TYPES } from '../../../types/paramsConfig.js';
import { accountIdentifierEmailSelector, updateAccountIdentifierEmail, } from '../../../views/AccountIdentifier/accountIdentifierSlice.js';
export const LoginEmailInput = () => {
    const { t } = useTranslation();
    const emailState = useAppSelector(emailSelector);
    const emailValue = useAppSelector(accountIdentifierEmailSelector);
    const activeView = useAppSelector(activeViewSelector);
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (activeView === FORM_TYPES.TWO_STEP_LOGIN) {
            dispatch(updateEmail(emailValue.value));
        }
    }, []);
    const onBlurEmail = ({ target: { value } }, isTouched) => {
        if (isTouched) {
            const emailString = value;
            const hasError = !validateEmail(emailString);
            dispatch(updateEmailError(hasError));
            if (hasError) {
                dispatch(updateEmailErrorMessage(t('loginregistration.email.validation.error')));
            }
        }
    };
    const emailOnChange = ({ target: { value }, }) => {
        if (activeView === FORM_TYPES.TWO_STEP_RETURNING) {
            dispatch(updateAccountIdentifierEmail(value));
        }
        if (activeView === FORM_TYPES.TWO_STEP_LOGIN) {
            dispatch(updateAccountIdentifierEmail(value));
            // TODO: replace that with navigateTo
            dispatch(setActiveView(FORM_TYPES.TWO_STEP_ACCOUNT_IDENTIFIER));
        }
        dispatch(updateEmail(value));
    };
    const { value, error, errorMessage } = emailState;
    return (_jsx(Input, { dataTestId: "email-input", value: value, onChange: emailOnChange, type: 'email', name: 'email', formLabel: t('loginregistration.login.email.headerInput'), placeholder: t('loginregistration.login.email.placeholder'), hasError: error, errorText: errorMessage, onBlur: onBlurEmail, autoComplete: 'username' }));
};
//# sourceMappingURL=LoginEmailInput.js.map